/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveAddressProviderLike,
  ICurveAddressProviderLikeInterface,
} from "../ICurveAddressProviderLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
    ],
    name: "get_address",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveAddressProviderLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveAddressProviderLikeInterface {
    return new utils.Interface(_abi) as ICurveAddressProviderLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveAddressProviderLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveAddressProviderLike;
  }
}
